import {isNullOrUndefined} from "util";
import {Injectable} from "@angular/core";
import {HttpService} from "../../_service/http.service";

@Injectable()
export class ViewSettingService {

  constructor(private httpService: HttpService) {
  }

  public isObjectShowed(s: string, result: boolean = true): boolean {
    let settingsList: any[];
    if (isNullOrUndefined(sessionStorage.getItem('view-setting'))) {
      return true;
    }
    settingsList = JSON.parse(sessionStorage.getItem('view-setting'));
    const element = settingsList.find(x => x.name === s);
    if (isNullOrUndefined(element)) {
      return result;
    } else {
      return element.status;
    }
  }

  public isPaymentShowed(s: string[]): boolean {
    let settingsList: any[];
    settingsList = JSON.parse(sessionStorage.getItem('payment-allowed'));
    if (isNullOrUndefined(settingsList)) {
      return true;
    }
    return settingsList.some(r => s.indexOf('' + r) >= 0);
  }

  public async getSettings() {
    const sb = [];
    sb.push('rest/');
    sb.push(localStorage.getItem('organizationAlias'));
    sb.push('/getViewSetting');

    return await this.httpService.getData(sb.join(''))
      .then((data) => {
        sessionStorage.setItem('timezone', data.timezone);
        sessionStorage.setItem('payment-allowed', data.paymentAllowedArray);
        sessionStorage.setItem('view-setting', data.viewSettings);
        return data;
      });
  }

  public async initStylesAndSvg(loadSvg?) {

    if (isNullOrUndefined(loadSvg)) {
      loadSvg = true;
    }

    let organizationAlias = localStorage.getItem('organizationAlias');
    let cssJson;
    try {
      cssJson = JSON.parse(sessionStorage.getItem("cssTheme"));
    } catch (e) {
      cssJson = null;
    }

    if (!isNullOrUndefined(cssJson)
      && cssJson.organizationAlias === organizationAlias) {
      sessionStorage.removeItem("inlineSVGrev");
      sessionStorage.removeItem("inlineSVGdata");
      if (loadSvg) {
        this.initSvg(cssJson.cssTheme);
      }
      return cssJson.cssTheme;
    } else {
      const sb = [];
      sb.push('rest/');
      sb.push(organizationAlias);
      sb.push('/getCSSName');

      let result = {cssTheme: null, organizationAlias: null};

      await this.httpService.getData(sb.join(''))
        .then((data) => {
          result.cssTheme = data._body;
          result.organizationAlias = organizationAlias;
        });

      try {
        sessionStorage.setItem("cssTheme", JSON.stringify(result));
      } finally {
      }
      if (loadSvg) {
        this.initSvg(result.cssTheme);
      }
      return result.cssTheme;
    }
  }

  private initSvg(ukName) {
    const file = 'img/svg-pack-' + ukName + '.svg', // путь к файлу спрайта на сервере
      revision = 1;            // версия спрайта
    if (!document.createElementNS || !document.createElementNS('http://www.w3.org/2000/svg', 'svg').createSVGRect) {
      return true;
    }
    let request, data;
    const isLocalStorage = !isNullOrUndefined(window.sessionStorage),
      insertIT = function () {
        const elem = document.createElement('div');
        elem.id = 'svg-data';
        elem.innerHTML = data;
        document.body.insertAdjacentElement('afterbegin', elem);
        if (!isNullOrUndefined(ukName) && ukName !== '') {
          document.body.insertAdjacentHTML('afterbegin',
            '<link id="ukStyle" rel="stylesheet" type="text/css" href="css/theme-' + ukName + '.css">');
        }
      },
      insert = function () {
        if (document.body) {
          insertIT();
        } else {
          document.addEventListener('DOMContentLoaded', insertIT);
        }
      };
    if (isLocalStorage && sessionStorage.getItem('inlineSVGrev') === revision.toString()) {
      data = sessionStorage.getItem('inlineSVGdata');
      if (data) {
        insert();
        return true;
      }
    }
    try {
      request = new XMLHttpRequest();
      request.open('GET', file, true);
      request.onload = function () {
        if (request.status >= 200 && request.status < 400) {
          data = request.responseText;
          insert();
          if (isLocalStorage) {
            sessionStorage.setItem('inlineSVGdata', data);
            sessionStorage.setItem('inlineSVGrev', revision.toString());
          }
        }
      };
      request.send();
    } catch (e) {
    }
  }
}



// WEBPACK FOOTER //
// D:/dev/smartcityspace_git/web/frontend/src/main/frontend/src/app/main-page/view-setting-service/view-setting.service.ts